import config from "@/config"
import http from "@/utils/request"

export default {
  ai_sessions: {
    add: {
      url: `${config.API_URL}/ai_sessions`,
      name: "新增一个AI会话记录",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.ai_sessions.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/ai_sessions`,
      name: "编辑一个AI会话记录",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.ai_sessions.item', ...data });
      }
    },
    delete: {
      url: `${config.API_URL}/ai_sessions`,
      name: "批量删除AI会话记录",
      post: async function (ai_sessions_id) {
        return await http.post(this.url, { method: 'del.ai_sessions.list', ai_sessions_id });
      }
    },
    item: {
      url: `${config.API_URL}/ai_sessions`,
      name: "获取一个AI会话记录详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.ai_sessions.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/ai_sessions`,
      name: "获取AI会话记录列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.ai_sessions.list', ...data });
      }
    }
  },
  ai_messages: {
    list: {
      url: `${config.API_URL}/ai_messages`,
      name: "获取AI会话记录消息列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.ai_messages.list', ...data });
      }
    }
  },
  ai_suggestions: {
    list: {
      url: `${config.API_URL}/ai_suggestions`,
      name: "获取Ai常见问题列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.ai_suggestions.list', ...data });
      }
    }
  }
}
